export default __webpack_public_path__ + "static/hero_maid_desktop-d38f02cdc3c080aa2d3fae6ba6de312f.webp";